export const headers = {
  header: 'About this webinar',
  subHeader: "In this webinar, you'll:",
};

export const WEBINAR_DURATION = 45 * 60 * 1000; // 45 minutes in milliseconds

// # minutes after which a user can rate the webinar after leaving the call
export const WEBINAR_CUT_OFF = 30 * 60 * 1000;
